var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomLooks5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 96 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520 776q44 0 69.5-25.5T615 681v-57q0-44-25.5-70T520 528h-80v-57h128q20 0 33.5-14t13.5-34q0-20-13.5-33.5T568 376H408q-26 0-44.5 18.5T345 439v122q0 26 18.5 44.5T408 624h112v57H392q-20 0-33.5 13.5T345 728q0 20 14 34t34 14h127ZM212 970q-53 0-89.5-36.5T86 844V308q0-53 36.5-89.5T212 182h536q53 0 89.5 36.5T874 308v536q0 53-36.5 89.5T748 970H212Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLooks5);
export default __webpack_public_path__ + "static/media/custom-looks-5.99dfe6237b23b4182a277f417b8746a2.svg";
export { ForwardRef as ReactComponent };